import { atom } from 'jotai';
import { atomFamily } from 'jotai/utils';

import { logger } from '@service-initiation/shared-clients-osp-logger';
import { getStores } from '@service-initiation/tech-care-data-access-tech-care-services';

import { fullAddressAtom } from './fullAddressAtom';
import { geolocationAtom } from './geolocationAtom';
import { postalCodeAtom } from './postalCodeAtom';

export const availableStoresAsyncAtom = atomFamily(
  (calcNextAvailability?: boolean) =>
    atom(async (get) => {
      const geolocation = get(geolocationAtom);
      const fullAddress = get(fullAddressAtom);
      const postalCode = get(postalCodeAtom);
      if (!fullAddress && !geolocation && !postalCode) {
        logger.info('No stores found for the given location');
        return [];
      }

      return await getStores({
        calcNextAvailability: calcNextAvailability || false,
        fullAddress: fullAddress?.address,
        geoLocation: geolocation,
        maxDistance: 60,
        maxNumOfStoresToReturn: 10,
        postalCode: postalCode,
      });
    })
);
